import React from "react";

const MenuIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_7172_3271)">
        <path
          d="M36.6673 8L18.334 8"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.6673 16L7.33398 16"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.666 24H25.666"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7172_3271">
          <rect
            width="32"
            height="44"
            fill="white"
            transform="translate(0 32) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MenuIcon;
